<template>
  <div class="row">
    <div class="col-12 mb-5">
      <h4 class="title font-weight-bold text-uppercase">
        Simplifique sua vida, escolha um de nossos planos e comece a aproveitar.
      </h4>
    </div>

    <div class="col-md-4 mb-4 cardDiv" v-for="(item, i) in planos" :key="i">
      <div class="cardBorder">
        <p v-if="item.recomendado == 1" class="text-center recomendado">RECOMENDADO</p>
        <b-card
          :title="item.nome"
          :img-src="item.url_img"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem;"
          class="mb-2"
        >
          <b-card-text>
            {{item.descricao}}
          </b-card-text>

          <p v-if="item.recomendado == 1" class="mt-3 text-center price">{{item.preco}}</p>
          <p v-else class="mt-5 text-center price">{{item.preco}}</p>

          <button class="btn btn-success btn-block mt-2" @click="showContractPlan(item.id)">Assinar plano</button>
        </b-card>
      </div>
    </div>

    <b-modal
      size="md"
      id="modalDados"
      header-text-variant="light"
      centered
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <div class="container">
        <h4 class="c-orange text-center">Favor inserir os dados de quem está solicitando</h4>

        <div class="mt-4">
          <label>Nome do solicitante</label>
          <input
            type="text" 
            class="form-control cursor-pointer"
            v-model="data.name"
            placeholder="Insira o nome do solicitante"
          >
        </div>

        <div class="mt-2">
          <label>Telefone solicitante</label>
          <input 
            type="text" 
            v-mask="['(##) #####-####', '(##) ####-####']"
            class="form-control cursor-pointer"
            v-model="data.phone"
            placeholder="Insira o telefone do solicitante"
          >
        </div>
      
        <div class="mt-4 text-right">
          <div class="row">
            <div class="col-6">
              <b-button class="mr-2 btn-block" variant="danger" @click="close()">
                Fechar
              </b-button>
            </div>
            <div class="col-6">
              <b-button variant="success" class="btn-block" @click="verifyData()">
                Próximo
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
export default {
  name:'AssinaturaAppSite',
  mixins: [makeToast],
  data() {
    return {
      planos: null,
      data: {
        name: '',
        phone:'',
        plano_id: null
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.showPlanos();
  },

  methods: {
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosAppLojista')
      .then((response) => {
        this.planos = response.data;
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },

    verifyData(){
  
      if(!this.data.name){
        this.makeToast('Erro!', 'Favor inserir o nome do solicitante!', 'danger');
        return;
      }
        
      if(!this.data.phone){
        this.makeToast('Erro', 'Favor inserir o telefone do solicitante!', 'danger');
        return;
      }
      
      let phone = this.data.phone;
      this.data.phone = phone.replace(/[^0-9]+/g,'');
          
      if(this.data.phone.length < 10){
        this.makeToast('Erro', 'Favor preencher corretamento o número de telefone!', 'danger');
        return;
      }

      this.send();
    },

    close(){
      this.data = {};
      this.$bvModal.hide('modalDados')
    },

    send() {
      this.$bvModal.hide('modalDados');
      
      const isDemo = this.dadosUsuario.informacoes.segmentos.length === 0 ? true : false;
      let phone = this.data.phone;
      let plano_id = this.dadosUsuario.plano_id;

      const data = {
        lojista_id: this.dadosUsuario.informacoes.id,
        status: 1,
        phone: phone.replace(/[^0-9]+/g,''),
        assinatura: true,
        plano_id: plano_id,
        usuario_id: this.dadosUsuario.id,
        nome: !isDemo ? this.data.name : this.dadosUsuario.nome_usuario,
        email: this.dadosUsuario.email,
        cpf_cnpj: this.dadosUsuario.cnpj,
        street: !isDemo ? this.dadosUsuario.informacoes.endereco : "",
        district: !isDemo ? this.dadosUsuario.informacoes.bairro : "",
        number: !isDemo ? this.dadosUsuario.informacoes.numero : "",
        zip_code: !isDemo ? this.dadosUsuario.informacoes.cep : "",
        complement: !isDemo ? this.dadosUsuario.informacoes.complemento : "",
        city: !isDemo ? this.dadosUsuario.informacoes.cidade.nome : "",
        state: !isDemo ? this.dadosUsuario.informacoes.estado.uf : "",
        valid_ass: false
      }

      this.$store.dispatch('lojistaSolicitaApp', data)
        .then((resp) => {
          this.response = resp;

          this.$root.$emit('valid-status-app');

          setTimeout(() => {
            this.$router.push({ name: 'lojista-cartão-credito-app-ass' }); 
          }, 1000);
        })
        .catch((error) => {
          this.makeToast('Opa!', 'Infelizmente ocorreu um erro, favor tentar novamente!!!', 'danger');
        }) 
        .finally(() => {
          this.$store.dispatch('endLoader');     
        });
    },

    showContractPlan(id) {
      this.dadosUsuario.plano_id = id;

      this.$store.dispatch('startLoader');   
      this.$store.dispatch('validarContaIugu', this.dadosUsuario.id)
        .then((response) => {
          if(response.data.valid === true) {
            this.$bvModal.show('modalDados');
          } else {
            this.makeToast('Opss!', 'Antes de solicitar o App é preciso configurar sua conta de recebimento!', 'danger');
            this.$router.push({ name: 'lojista-iugu-update' });
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');        
        });
    }
  }
}
</script>

<style scoped>
.cardDiv {
  display: flex;
  justify-content: center;
}
.recomendado {
  font-size: 25px;
  color: #FFF;
  background-color: #ff4a4a;
}
.cardBorder {
  border: 1px solid #ff4a4a;
  border-radius: 10px;
  padding: 25px;
}
.price {
  font-size: 25px;
  font-weight: bold;
}
</style>